module.exports = __webpack_public_path__ + "static/media/1443603129.529fd337.jpg";